<template>
    <div>
        <el-dialog v-dialogDrag :visible.sync="visible" width="90%" :close-on-click-modal="false" append-to-body
            @close="close">
            <span slot="title" class="dialog-title">数据历史</span>
            <div class="dialoginfo">
                <div class="tabtop" style="margin: 0px 0px 20px">
                    <div @click="choose(1)">
                        <div :class="currenindex == 1 ? 'active' : 'text'">环境监测</div>
                    </div>
                    <div @click="choose(2)">
                        <div :class="currenindex == 2 ? 'active' : 'text'">能耗监测</div>
                    </div>
                    <div @click="choose(3)">
                        <div :class="currenindex == 3 ? 'active' : 'text'">固含量</div>
                    </div>
                    <div @click="choose(4)">
                        <div :class="currenindex == 4 ? 'active' : 'text'">外加剂罐</div>
                    </div>
                </div>
                <div style="margin-bottom: 10px">
                    <!-- <el-input v-model="carNo" placeholder="请输入"></el-input>
                    <el-button style="margin-left: 10px" class="bottom_all_two" @click="initSurplusList">查询</el-button> -->
                    <el-form :inline="true" :model="query" class="demo-form-inline">
                        <el-form-item label="监控内容">
                            <el-input v-model="query.groupName" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="在线状态">
                            <el-select v-model="query.status" placeholder="请选择" clearable>
                                <el-option label="在线" :value="1"></el-option>
                                <el-option label="离线" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="数据传输时间">
                            <!-- <el-date-picker v-model="query.terminalTime" type="datetimerange" align="right"
                                start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy/MM/dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                            </el-date-picker> -->
                            <el-date-picker
                                v-model="terminalTime1"
                                unlink-panels
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange"
                                :default-time="['00:00:00', '23:59:59']"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button style="margin-left: 10px" class="bottom_all" @click="initSurplusList">查询</el-button>
                            <el-button style="margin-left: 10px" class="bottom_all" @click="reset">重置</el-button>
                            <el-button v-if="currenindex == 2" style="margin-left: 10px" class="bottom_all"
                                @click="lineChange">数据折线图</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-loading="tableLoading" class="card_info">
                    <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border
                        stripe style="width: 100%" :data="dataArray" height="35vh" tooltip-effect="dark">
                        <el-table-column label="监控内容" align="center" prop="groupName"></el-table-column>
                        <el-table-column label="在线状态" align="center" prop="status">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status == 1" style="color: #67c23a;">设备在线</span>
                                <span v-else style="color: #f56c6c;">设备离线</span>
                            </template>
                        </el-table-column>
                        <template v-if="currenindex == 1">
                            <el-table-column label="环境湿度(RH%)" align="center" prop="rh">
                                <template slot-scope="scope">
                                    {{ scope.row.rh? (scope.row.rh / 10): '' }}
                                </template>
                            </el-table-column>
                            <el-table-column label="环境温度(°C)" align="center" prop="temp">
                                <template slot-scope="scope">
                                    {{ scope.row.temp? (scope.row.temp / 10): '' }}
                                </template>
                            </el-table-column>
                            <el-table-column label="噪声(dB)" align="center" prop="db">
                                <template slot-scope="scope">
                                    {{ scope.row.db? (scope.row.db / 10): '' }}
                                </template>
                            </el-table-column>
                            <el-table-column label="PM2.5(ug/m³)" align="center" prop="pm25"></el-table-column>
                            <el-table-column label="PM10(ug/m³)" align="center" prop="pm100"></el-table-column>
                        </template>
                        <template v-else-if="currenindex == 2">
                            <el-table-column label="相电压(V)" align="center" prop="ua">
                                <template slot-scope="scope">
                                    {{ scope.row.ua }}, {{ scope.row.ub }}, {{ scope.row.uc }}
                                </template>
                            </el-table-column>
                            <el-table-column label="相电流(A)" align="center" prop="ia">
                                <template slot-scope="scope">
                                    {{ scope.row.ia }}, {{ scope.row.ib }}, {{ scope.row.ic }}
                                </template>
                            </el-table-column>
                            <el-table-column label="功率因数(%)" align="center" prop="cos"></el-table-column>
                            <el-table-column label="瞬时总功率(KW)" align="center" prop="pf"></el-table-column>
                            <el-table-column label="正向总功耗(KWH)" align="center" prop="kwh"></el-table-column>
                        </template>
                        <template v-else-if="currenindex == 3">
                            <el-table-column label="固含量（%）" align="center" prop="guhanliang"></el-table-column>
                        </template>
                        <template v-else-if="currenindex == 4">
                            <el-table-column label="液位仪库存（吨）" align="center" prop="h">
                                <template slot-scope="scope">
                                    {{ scope.row.h ? (scope.row.h / 1000).toFixed(2) : "" }}
                                </template>
                            </el-table-column>
                        </template>
                        <el-table-column label="数据传输时间" align="center" prop="terminalTime"></el-table-column>
                    </el-table>
                </div>
                <el-pagination :current-page.sync="query.page" :page-size="query.limit" layout="prev,pager,next"
                    :total="total" @current-change="initSurplusList()"></el-pagination>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="close">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="chartVisible" width="90%" :close-on-click-modal="false">
            <span slot="title" class="dialog-title">数据折线图</span>
            <div v-loading="lineLoading">
                <!-- <el-form :inline="true" :model="lineQuery" class="demo-form-inline">
                    <el-form-item label="查询时间段">
                        <el-date-picker
                            v-model="terminalTime2"
                            unlink-panels
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :default-time="['00:00:00', '23:59:59']"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button style="margin-left: 10px" class="bottom_all" @click="initLine">查询</el-button>
                        <el-button style="margin-left: 10px" class="bottom_all" @click="resetLine">重置</el-button>
                    </el-form-item>
                </el-form> -->
                <div id="mainLine"></div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="chartVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import echarts from 'echarts';
import { environmentMonitoringData, energyMonitoringData, slurrySolidContentData, additiveTankData } from '@/api/smart/environmentalMonitor.js'
export default {
    props: {
        visible: {
            type: Boolean,
        },
    },
    data() {
        return {
            title: '料仓环境监测',
            status: '设备在线',
            currenindex: 1,
            tableLoading: false,
            query: {
                status: '',
                groupName: '',
                // terminalTime: [new Date().toLocaleDateString(), new Date().toLocaleDateString()],
                page: 1,
                limit: 10,
            },
            total: 0,
            dataArray: [],

            chartVisible: false,
            lineEcharts: null,
            chartData: {},

            lineQuery: {
                page: 1,
                limit: 999999,
                // terminalTime: [new Date().toLocaleDateString(), new Date().toLocaleDateString()],
            },
            terminalTime1: [new Date().toLocaleDateString(), new Date().toLocaleDateString()],
            terminalTime2: [new Date().toLocaleDateString(), new Date().toLocaleDateString()],
            lineLoading: false,
        };
    },
    watch: {
        visible(val) {
            if(val) {
                this.initSurplusList();
            }
        }
    },
    mounted() {
        const _this = this
        _this.dataArray = []
        _this.currenindex = 1
        this.terminalTime1 = [new Date().Format("yyyy-MM-dd") + " 00:00:00", new Date().Format("yyyy-MM-dd hh:mm:ss")]
        // 近十二小时
        this.terminalTime2 = [new Date(new Date().getTime() - 12 * 60 * 60 * 1000).Format("yyyy-MM-dd hh:mm:ss"), new Date().Format("yyyy-MM-dd hh:mm:ss")]
        // this.$nextTick(() => {
        //     _this.lineEcharts = echarts.init(document.getElementById('mainLine'));
        // })
    },
    methods: {
        choose(num) {
            this.dataArray = []
            this.query.page = 1
            this.currenindex = num
            this.chartVisible = false
            this.reset();
        },
        initSurplusList() {
            this.query.startTime = this.terminalTime1[0]
            this.query.endTime = this.terminalTime1[1]
            if (this.currenindex === 1) {
                environmentMonitoringData(this.query).then(res => {
                    this.dataArray = res.data.list
                    this.total = res.data.total
                })
            } else if (this.currenindex === 2) {
                energyMonitoringData(this.query).then(res => {
                    this.dataArray = res.data.list
                    this.total = res.data.total
                })
            } else if (this.currenindex === 3) {
                slurrySolidContentData(this.query).then(res => {
                    this.dataArray = res.data.list
                    this.total = res.data.total
                })
            } else if (this.currenindex === 4) {
                additiveTankData(this.query).then(res => {
                    this.dataArray = res.data.list
                    this.total = res.data.total
                })
            }
        },
        reset() {
            this.query = {
                status: '',
                groupName: '',
                terminalTime: '',
                page: 1,
                limit: 10,
                total: 0
            }
            this.terminalTime1 = [new Date().Format("yyyy-MM-dd") + " 00:00:00", new Date().Format("yyyy-MM-dd hh:mm:ss")]
            this.initSurplusList();
        },
        initLine() {
            this.lineLoading = true
            this.lineQuery.startTime = this.terminalTime2[0]
            this.lineQuery.endTime = this.terminalTime2[1]
            energyMonitoringData(this.lineQuery).then(res => {
                this.lineLoading = false
                this.dataArray = res.data.list.reverse()
                // this.getChartOptions()
                this.lineEcharts = echarts.init(document.getElementById('mainLine'))
                this.getAllTime(this.dataArray)
            }).catch(() => {
                this.lineLoading = false
            })
        },
        resetLine() {
            this.lineQuery = {
                page: 1,
                limit: 999999,
                terminalTime: '',
            }
            this.terminalTime2 = [new Date(new Date().getTime() - 12 * 60 * 60 * 1000).Format("yyyy-MM-dd hh:mm:ss"), new Date().Format("yyyy-MM-dd hh:mm:ss")]
            this.initLine()
        },
        lineChange() {
            this.chartData = {}
            this.chartVisible = true
            this.initLine()
        },
        getAllTime(data) {
            let arr = [],
                arr2 = []
            data.forEach(item => {
                const time = item.terminalTime
                if (!arr.includes(time)) {
                    arr.push(time)
                }
                if (!arr2.includes((time.split(' ')[1]).split(':')[0] + ':00')) {
                    arr2.push((time.split(' ')[1]).split(':')[0] + ':00')
                }
            });
            this.calcData(data, arr2)
        },
        calcData(data, time) {
            let D1 = new Array(time.length).fill(''),
                D2 = new Array(time.length).fill(''),
                D3 = new Array(time.length).fill(''),
                D4 = new Array(time.length).fill(''),
                D5 = new Array(time.length).fill(''),
                D6 = new Array(time.length).fill('')

            for (let a = 0; a < time.length; a++) {
                for (let b = 0; b < data.length; b++) {
                    const T = (data[b].terminalTime.split(' ')[1]).split(':')[0] + ':00'
                    if (data[b].groupName === '1号主机能耗监测' && T === time[a]) {
                        D1[a] = data[b].kwh
                    } else if (data[b].groupName === '2号主机能耗监测' && T === time[a]) {
                        D2[a] = data[b].kwh
                    } else if (data[b].groupName === '1号斜皮带能耗监测' && T === time[a]) {
                        D3[a] = data[b].kwh
                    } else if (data[b].groupName === '2号斜皮带能耗监测' && T === time[a]) {
                        D4[a] = data[b].kwh
                    } else if (data[b].groupName === '1号平皮带能耗监测' && T === time[a]) {
                        D5[a] = data[b].kwh
                    } else if (data[b].groupName === '2号平皮带能耗监测' && T === time[a]) {
                        D6[a] = data[b].kwh
                    }
                }
            }

            this.chartData = {
                time: time,
                '1号主机能耗监测': D1,
                '2号主机能耗监测': D2,
                '1号斜皮带能耗监测': D3,
                '2号斜皮带能耗监测': D4,
                '1号平皮带能耗监测': D5,
                '2号平皮带能耗监测': D6,
            }
            // console.log(this.chartData, time);
            this.getChartOptions()
        },
        getChartOptions() {
            const _this = this
            var option;

            option = {
                title: {
                    text: '正向总能耗（KWH）'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['1号主机能耗监测', '2号主机能耗监测', '1号斜皮带能耗监测', '2号斜皮带能耗监测', '1号平皮带能耗监测', '2号平皮带能耗监测']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: _this.chartData.time
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '1号主机能耗监测',
                        type: 'line',
                        stack: 'Total',
                        data: _this.chartData['1号主机能耗监测']
                    },
                    {
                        name: '2号主机能耗监测',
                        type: 'line',
                        stack: 'Total',
                        data: _this.chartData['2号主机能耗监测']
                    },
                    {
                        name: '1号斜皮带能耗监测',
                        type: 'line',
                        stack: 'Total',
                        data: _this.chartData['1号斜皮带能耗监测']
                    },
                    {
                        name: '2号斜皮带能耗监测',
                        type: 'line',
                        stack: 'Total',
                        data: _this.chartData['2号斜皮带能耗监测']
                    },
                    {
                        name: '1号平皮带能耗监测',
                        type: 'line',
                        stack: 'Total',
                        data: _this.chartData['1号平皮带能耗监测']
                    },
                    {
                        name: '2号平皮带能耗监测',
                        type: 'line',
                        stack: 'Total',
                        data: _this.chartData['2号平皮带能耗监测']
                    }
                ]
            };

            option && _this.lineEcharts.setOption(option);
        },
        close() {
            this.$emit('historyChange')
        },
    },
};
</script>

<style lang="scss" scoped>
.tabtop {
    width: 760px;
}

.dialog-title {
    font-size: 16px;
    font-weight: bold;
    padding-right: 40px;
}

.el-input,
.el-select {
    width: 240px;
}

#mainLine {
    width: 100%;
    height: 40vh;
}
</style>